module.exports = __webpack_public_path__ + "static/media/insuranceBackground.39cf2595.webp";